import { render, staticRenderFns } from "./_SettingHe.vue?vue&type=template&id=25e4c944&"
import script from "./_SettingHe.vue?vue&type=script&lang=js&"
export * from "./_SettingHe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports